import I1Detail from './I1Detail';

export default I1Detail;
